import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';

import { FieldComponent } from './field.component';
import { ConvertDialogComponent } from './convert-dialog.component';

@Component({
  selector: 'app-convert-field',
  templateUrl: './convert-field.component.html',
  styleUrls: ['./convert-field.component.scss']
})
export class ConvertFieldComponent extends FieldComponent implements OnInit {

  @Output() standardConverted = new EventEmitter<any>();

  id: string = 'convert';
  standard: any;
  
  get valid(): boolean {return true}

  constructor(
    cd: ChangeDetectorRef,
    private dialog: MatDialog) { super(cd) }

  ngOnInit() {
    if (this.field.locked) { this.locked = true }
  }

  setValue(value) {
    this.value = value;
  }

  setStandard(standard) {
    this.standard = standard;
  }

  showInputDialog() {
    if (this.value == null) { return }
    let dialogRef = this.dialog.open(ConvertDialogComponent, {
      height: '240px',
      width: '320px',
      data: {
        standard: this.standard,
        value: this.value
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != null) {
        this.value = result.value;
        this.standard = result.standard
        this.standardConverted.emit({
          standard: this.standard,
          value: this.value
        });
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/app/forms/convert-field.component.ts